import React from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Ellipsis, Space } from 'antd-mobile'
import HomeIcon from '../Icon/HomeIcon'

import UserIcon from '../Icon/UserIcon'

import SelectLanguage from '../SelectLanguage'
import './index.less'
import { getUrlParam } from '../../utils';
import { setFromView } from '../../utils/session/store';
import AreaLabel from '../AreaLabel';

const Header = (props) => {
    const navigate = useNavigate();
    const {
        title = '',
        back = true,
        subTitle = '',
        callback,
        backHome = false,
        btns = [],
        showLangSwitch = false,
        lanArr = [],
        useTitle = false,
        showOrder = false,
        storeInfo = {},
        showArea = false,
        compact = false
    } = props;

    let fromName = useTitle ? title : getUrlParam('fname') || ''
    if (fromName) {
        fromName = decodeURIComponent(fromName)
    }

    const { storeArea = {} } = storeInfo
    const { areaType, area = '' } = storeArea


    const goBack = () => {

        const payFlag = getUrlParam('payflag')
        const areaId = getUrlParam('areaid')

        setFromView({
            hash: window.location.hash,
            timestamp: Date.now()
        })

        setTimeout(() => {
            setFromView(null)
        }, 10000)
        if (window.history.length > 1 && payFlag !== '1') {
            navigate(-1);
        } else {
            navigate('/home?areaid=' + areaId);
        }
    }

    return (
        <div className={`jm-headerview ${compact ? 'is-compact' : ''}`}>
            <header>
                <div className='jm-header-inner jm-flex'>
                    <div className='jm-flex-item'>
                    {back ? <div className='return-ico' onClick={() => callback ? callback() : goBack()}></div> : null}
                    {showOrder ? <div className='order-ico' onClick={() => navigate('/orders')}>
                        <UserIcon height={24} width={24} color="var(--adm-color-primary)" />
                    </div> : null}
                    <div className='hd-title'>
                        {title ? <div className='m-title'><Ellipsis content={fromName || title} /></div> : null}
                        {subTitle ? <div className='sub-title fs-12 ellips'><Ellipsis content={subTitle} /></div> : null}
                        {showArea ? <div className='text-gray'><AreaLabel areaType={areaType} area={area} /></div> : null}
                    </div>
                    </div>
                    {
                        backHome
                            ?
                            <div className='home-ico' onClick={() => { navigate('/home') }}><HomeIcon height={24} width={24} color="#5c5c5c" /></div>
                            :
                            null
                    }
                    {showLangSwitch && <div className='lan-box'><SelectLanguage lanItem={lanArr} storeInfo={storeInfo} /></div>}
                    {
                        btns && btns.length > 0
                            ?
                            <div className="commit-btn">
                                <Space>
                                    {
                                        btns.map((btn, index) => {
                                            const { name, onClick, icon } = btn
                                            return <div key={index}>
                                                {
                                                    icon
                                                        ?
                                                        <div style={{ padding: '0 5px' }} onClick={onClick}>{icon}</div>
                                                        :
                                                        <Button
                                                            key={index}
                                                            size='mini'
                                                            color='primary'
                                                            fill="none"
                                                            onClick={onClick}>
                                                            {name}
                                                        </Button>
                                                }
                                            </div>
                                        })
                                    }
                                </Space>
                            </div>
                            :
                            null
                    }
                </div>
            </header>
        </div>
    )
}

export default Header;
